import * as React from 'react';
import * as Datetime from 'jonshort-shim-react-bootstrap-date-picker';
import { isNull, isUndefined } from 'lodash';
import createReactClass from 'create-react-class';
import { FormControl  } from 'react-bootstrap';
import { getRandomKey } from '../../Utils'

const CustomControl = createReactClass({
    render(){
        let params = {...this.props};
        params.placeholder = "ДД.ММ.ГГГГ"

        return <FormControl {...params} />
    }
})

interface DateTimeProps{
    value?: string;
    onChangeValue: (value:string) => void;
    disabled: boolean;
    label?:string;
    maxDate?: string;
    minDate?:string;
    ignoreTitle?: boolean;
    onFocus?: () => void;
    onBlur?: () => void;
}

interface DateTimeState{
    open: boolean;
}

const isMax = (maxDate: string, value: string) =>{
    let maxNewDate = new Date(maxDate);
    maxNewDate.setDate(maxNewDate.getDate()+ 1);
    
    return (new Date(value)) <= maxNewDate
}

const isMin = (minDate: string, value: string) =>{
    let minNewDate = new Date(minDate);
    minNewDate.setDate(minNewDate.getDate() - 1);
    
    return (new Date(value)) >= minNewDate
}

class DateTime extends React.Component<DateTimeProps, DateTimeState>{
    private date: Datetime;
    
    constructor(){
        super();
        this.onChange = this.onChange.bind(this);
    }

    onChange(value){
        if(this.props.maxDate && isMax(this.props.maxDate, value) &&
            this.props.minDate && isMin(this.props.minDate, value)) {
          this.props.onChangeValue(isNull(value) ? "" : value);
        }else if(isUndefined(this.props.maxDate) || isUndefined(this.props.minDate)) {
          if(!isUndefined(this.props.maxDate) && isMax(this.props.maxDate, value)){
            this.props.onChangeValue(isNull(value) ? "" : value);
          }else if(!isUndefined(this.props.minDate) && isMin(this.props.minDate, value)){
            this.props.onChangeValue(isNull(value) ? "" : value);
          }else{
            if(isUndefined(this.props.maxDate) && isUndefined(this.props.minDate)){
              this.props.onChangeValue(isNull(value) ? "" : value);
            }else{
              this.props.onChangeValue("");
            }
          }
        }else{
          this.props.onChangeValue("");
        }
    }

    render(){
        const control = (
          <Datetime 
            ref={(date) => this.date = date }
            dateFormat="DD.MM.YYYY" 
            dayLabels={['Вс','Пн','Вт','Ср','Чт','Пт','Сб']}
            monthLabels={['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь']}
            weekStartsOn={1}
            customControl={<CustomControl />}
            placeholder="ДД.ММ.ГГГГ"
            maxDate={this.props.maxDate}
            minDate={this.props.minDate}
            showClearButton ={false} 
            onChange={this.onChange} 
            value={this.props.value}
            disabled={this.props.disabled}
            onFocus={() => this.props.onFocus && this.props.onFocus()}
            onBlur={() => this.props.onBlur && this.props.onBlur()}
          />
        )

        return !this.props.ignoreTitle ? (
            <div className="form-group" style={{marginLeft: "0px", marginRight: 0}}>
                { this.props.label && (<label className="control-label" >{this.props.label}</label>)}
                <span className="input-group">
                    {control}
                </span> 
            </div>
        ) : control;
    }
}

export default DateTime;


// WEBPACK FOOTER //
// ./src/components/controls/extensions/Datetime.tsx